import { useState } from 'react'
import { FiX, FiPhone } from 'react-icons/fi'
import { BEV_PHONE_LINK } from './bevContact'

const BANNER_DISMISSED_KEY = 'myscribbl_onboarding_banner_dismissed'

function OnboardingSkipBanner() {
  const [dismissed, setDismissed] = useState(() =>
    typeof window !== 'undefined' && localStorage.getItem(BANNER_DISMISSED_KEY) === 'true'
  )

  if (dismissed) return null

  const handleDismiss = () => {
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true')
    setDismissed(true)
  }

  return (
    <div className="onboarding-skip-banner">
      <FiPhone size={16} />
      <span>
        Complete your test call with Bev — it&apos;ll only take 1 minute
      </span>
      <a href={BEV_PHONE_LINK} className="onboarding-skip-banner-cta">Try it now</a>
      <button type="button" className="onboarding-skip-banner-close" onClick={handleDismiss} aria-label="Dismiss">
        <FiX size={16} />
      </button>
    </div>
  )
}

export default OnboardingSkipBanner
